export default __webpack_public_path__ + "static/media/youtube.c02f061a.svg";